import { render } from "./componentSuperior.vue?vue&type=template&id=d3090efc&scoped=true"
import script from "./componentSuperior.vue?vue&type=script&lang=js"
export * from "./componentSuperior.vue?vue&type=script&lang=js"

import "./componentSuperior.vue?vue&type=style&index=0&id=d3090efc&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3090efc"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
